/**
 * prepare webpack entry point for client bundle.
 *
 * @param clientAppConfig       object - apps /clientAppConfig.js
 * @param requireContexts       object - require.contexts for templates, components, styles and translations ready to be included into the bundle.
 * @param requireAppCallback    function - to require app specifics
 */
module.exports = (clientAppConfig = {}, requireContexts = {}, requireAppCallback = null) => {

    // prepare fallback for globals needed if some key libraries will not be included.
    require('./fallbackDefinitions')

    // get client utils
    const utils = require('./utils')

    // require app specifics
    if(typeof requireAppCallback === 'function'){
        requireAppCallback()
    }

    // init config
    require('./config').setConfig(
        clientAppConfig,
        {
            templates:  (requireContexts || {}).templates,
            components: (requireContexts || {}).components,
            styles:     (requireContexts || {}).styles,
        }
    )

    // init translations
    require('./translationManager').init(utils.language.requireTranslations((requireContexts || {}).translations || (() => {})))

    // run client app
    require('./app')
}